import React, { Component } from "react"
import ButtonsForm from "../../../components/ButtonsForm"
import { Link, Redirect } from 'react-router-dom'
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import helper from "../../../utils/helper"
import Select from '../../../components/Select'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { components } from 'react-select'
import { getClientesModulo, createOptionsClientes } from "../../../services/clientes"
import ConfirmDelete from "../../../components/ConfirmDelete"

class Form extends Component {
    userInfo = auth.getUserInfo()
    isCustomer = auth.isClient()

    state = {
        detalhes: { 
            cliente: this.isCustomer ? { label: this.userInfo.nome, value: this.userInfo.cliente } : { label: "Nenhum", value: null }, 
            nome: null, 
            tipo: {label: "Interno", value: "interno"}, 
            broker: null, 
            porta: 0, 
            qos: 0, 
            tls: false,
            topico_pub: null, 
            topico_sub: null, 
            usuario: null, 
            senha: null, 
            aplicacao: null, 
            dispositivo: null, 
            acesso: null 
        },
        cooldown: false,
        redirect: false,
        path: "",
        tab: 0,
        optionsClientes: [ { label: "Nenhum", value: null } ],
        optionsTipo: [
            {label: "Interno", value: "interno"},
            {label: "Externo", value: "externo"},
        ],
        optionsAplicacao: [],
        optionsDispositivo: [],
        optionsAcesso: [],
        dataTable: [],
        info: {
            interno: "Irá cadastrar um equipamento no modulo base e redirecionará os dados para nossa plataforma.",
            externo: "Irá enviar os dados para um broker externo de sua escolha."
        },
        hasChangedSomething: false
    }

    get redirectId() {
        if (this.props.isQuickRegister && this.props.redirectId) {
            return this.props.redirectId
        }

        return this.props?.match?.params?.id
    }

    componentDidMount = async () => {
        await getClientesModulo('lns').then((clientes) => this.setState({ optionsClientes: [...this.state.optionsClientes, ...createOptionsClientes(clientes)] }) )

        if (this.redirectId) {
            this.getData()
        } else {
            this.getAplicacoes()
        }
        
        this.getTipoAcessos()
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/redirecionamentos/' + this.redirectId + '/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            const cliente = this.state.optionsClientes.find((item) => {if(data.cliente == item.value) return item}) ?? null
            const tipo = this.state.optionsTipo.find((item) => item.value == data.tipo)

            this.getAplicacoes(data.cliente ?? false)

            this.setState({ 
                detalhes: { 
                    cliente: cliente,
                    nome: data.nome, 
                    tipo,
                    broker: data.broker,
                    porta: data.porta,
                    qos: data.qos,
                    tls: data.tls,
                    topico_pub: data.topico_pub,
                    topico_sub: data.topico_sub,
                    usuario: data.usuario,
                    senha: data.senha
                },
                dataTable: data.dispositivos_redirecionados
            })
        })
    }

    getAplicacoes = (clienteId = false) => {
        let requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        if(clienteId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + `/lns/application/?cliente=${clienteId}`
        }

        axios.get(requestURL, config_me).then(({ data }) => {
            let optionsAplicacao = data.results.map((item) => {
                return { label: item.name, value: item.id }
            })

            let aplicacaoSelecionada = null

            if (this.props.isQuickRegister && this.props.applicationId) {
                aplicacaoSelecionada = optionsAplicacao.find((item) => String(item.value) === String(this.props.applicationId))

                if (aplicacaoSelecionada) {
                    this.getDispositivos(aplicacaoSelecionada.value)
                }
            }

            this.setState((prevState) => ({
                optionsAplicacao,
                detalhes: {
                    ...prevState.detalhes,
                    aplicacao: aplicacaoSelecionada ?? prevState.detalhes.aplicacao
                }
            }))
        })
    } 

    getDispositivos = (applicationId) => {
        let requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + `/lns/application/${applicationId}/device/`
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            let optionsDispositivo = data.results.map((item) => {
                return { label: item.name, value: item.id }
            })

            let dispositivoSelecionado = null

            if (this.props.isQuickRegister && this.props.deviceId) {
                dispositivoSelecionado = optionsDispositivo.find((item) => String(item.value) === String(this.props.deviceId))
            }

            this.setState((prevState) => ({
                optionsDispositivo,
                detalhes: {
                    ...prevState.detalhes,
                    dispositivo: dispositivoSelecionado ?? prevState.detalhes.dispositivo
                }
            }))
        })
    }
    
    getTipoAcessos = () => {
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa +"/acesso/?meus_acessos=true", config_me).then(({ data }) => {
            const totalDeAcessos = data.total
            const acessosUtilizados = data.utilizados
          
            let optionsAcesso = totalDeAcessos.map((item) => { 
                let acessoContido = acessosUtilizados.find((acesso) => item.acesso_tipo == acesso.acesso_tipo)
                let isDisabled = false
                let disponiveis = item.tcount
                
                if(acessoContido) {
                    disponiveis = item.tcount - acessoContido.tcount
                    isDisabled = disponiveis == 0 
                }

                return { label: item.acesso_tipo__descricao, value: item.acesso_tipo, isDisabled, acessosDisponiveis: disponiveis } 
            })
           
            this.setState({optionsAcesso})
        })
    }

    handleChange = (field, value, isNumber = false) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const span = document.getElementById(`validacao-${field}`)

        if(isNumber){
           value = helper.justNumbers(value)
        }
        
        detalhes[field] = value
        
        if(span) {
            span.innerHTML = ""
        }

        if(field == "cliente") {
            detalhes["aplicacao"] = null
            detalhes["dispositivo"] = null
            
            this.getAplicacoes(value.value)

            this.setState({ optionsAplicacao: [], optionsDispositivo: [] })
        }  
        
        if(field == "aplicacao") {
            detalhes["dispositivo"] = null
            this.getDispositivos(value.value)

            this.setState({ optionsDispositivo: [] })

            let span = document.querySelector("#validacao-dispositivo")
            span.innerHTML = ""
        }

        if(field == "tipo") {
            this.setState({ dataTable: [], optionsAcesso: [] })
            this.getTipoAcessos()
        }

        this.setState({ detalhes })
    }

    addDispositivo = () => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const dataTable = [...this.state.dataTable]
        let optionsAcesso = [...this.state.optionsAcesso]

        let dispositivoJaAdicionado = dataTable.find((item) => item.dispositivo.value == detalhes.dispositivo.value)
        let span = document.querySelector("#validacao-dispositivo")

        if(dispositivoJaAdicionado) {
            span.innerHTML = "Esse dispostivo já foi adicionado."
            return
        }

        span.innerHTML = ""

        if(detalhes.tipo?.value == "interno") {
            optionsAcesso = optionsAcesso.map((item) => {
                if(item.value == detalhes.acesso.value){
                    item.acessosDisponiveis -= 1
                    item.isDisabled = item.acessosDisponiveis === 0
                }

                return item
            })

            dataTable.push({aplicacao: detalhes.aplicacao, dispositivo: detalhes.dispositivo, acesso: detalhes.acesso})
        } else {
            dataTable.push({aplicacao: detalhes.aplicacao, dispositivo: detalhes.dispositivo})
        }

        detalhes.aplicacao = null
        detalhes.dispositivo = null
        detalhes.acesso = null

        this.setState({ dataTable, detalhes, optionsAcesso, hasChangedSomething: true })
    }

    deletarDispositivo = (keyDelete) => {
        const detalhes = this.state.detalhes
        let dataTable = [...this.state.dataTable]
        let optionsAcesso = [...this.state.optionsAcesso]
        let dispositivo = dataTable.find((item, index) => index === keyDelete)

        if(detalhes.dispositivo?.value == dispositivo.dispositivo.value){
            let span = document.querySelector("#validacao-dispositivo")
            span.innerHTML = ""
        }

        dataTable = dataTable.filter((item, index) => index !== keyDelete)
        
        this.setState({ dataTable, optionsAcesso, hasChangedSomething: true })
    }

    handleQuickRegister = async () => {
        return new Promise((resolve) => {
            const { detalhes, dataTable } = this.state

            const temDadosBasicos = detalhes.nome && detalhes.tipo

            if (!temDadosBasicos && dataTable.length === 0) {
                helper.dispatchEvent("showAviso", {
                    message: "Nenhum dado preenchido, deseja finalizar sem adicionar um redirecionamento?",
                    callback: () => resolve({ success: true }),
                })

                return
            }

            this.saveAction(false, resolve)
        })
    }

    saveAction = (novoCadastro, resolve = null) => {
        const { detalhes, dataTable } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""

        if (this.redirectId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/redirecionamentos/' + this.redirectId + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/redirecionamentos/create/'
            verb = 'post'
        }

        let data = {
            cliente: detalhes.cliente.value,
            nome: detalhes.nome,
            tipo: detalhes.tipo?.value ?? null
        }

        if(detalhes.tipo?.value == "externo") {
            data["broker"] = detalhes.broker
            data["porta"] = detalhes.porta
            data["qos"] = detalhes.qos
            data["tls"] = detalhes.tls
            data["topico_pub"] = detalhes.topico_pub
            data["topico_sub"] = detalhes.topico_sub
            data["usuario"] = detalhes.usuario
            data["senha"] = detalhes.senha
        } 

        data["dispositivos_redirecionados"] = dataTable.map((item) => {
            if(detalhes.tipo?.value == "interno") {
                return {aplicacao_id: item.aplicacao.value, acesso_id: item.acesso.value, dispositivo_id: item.dispositivo.value}
            } else {
                return {aplicacao_id: item.aplicacao.value, dispositivo_id: item.dispositivo.value}
            }
        })

        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                const mensagemErrosDispositivos = helper.formatarDispositivosErros(res.data?.dispositivos_erros)
                const mensagemBase = `Redirecionamento ${verb === "post" ? "criado" : "editado"} com sucesso.`
                const mensagem = mensagemErrosDispositivos
                    ? `${mensagemBase}<br/><br/>Porém, os dispositivos abaixo não puderam ser vinculados:<br/>${mensagemErrosDispositivos}`
                    : mensagemBase

                helper.dispatchEvent("showAviso", {
                    message: mensagem,
                    callback: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    redirectId: res.data.id,
                                })
                            }

                            return
                        }
                        this.setState({
                            redirect: true,
                            path: "/lns/redirecionamentos",
                            hasChangedSomething: false
                        })
                    },
                    callbackClose: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    redirectId: res.data.id,
                                })
                            }

                            return
                        }
                        if (verb === "post") {
                            window.location.href = `/lns/redirecionamentos/${res.data.id}/editar`
                            setTimeout(() => {
                                window.location.reload()
                                this.setState({ hasChangedSomething: false })
                            }, 1000)

                            return
                        }
                        this.setState({ hasChangedSomething: false })
                    }
                })
            }
        }).catch((error) => {
            if (resolve) {
                resolve({
                    success: false,
                })
            }
            let erros = Object.entries(error.response.data)

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    if (erros[i][0] == "erro") {
                        helper.dispatchEvent("showAviso", { message: erros[i][1] })
                    }

                    let span = document.querySelector(`#validacao-${erros[i][0]}`)
                    if (span) span.innerHTML = erros[i][1]
                }
            }
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    handleTab = (index) => this.setState({ tab: index })

    showInfo = (info, callback = null) => {
        helper.dispatchEvent("showAviso", {
            message: info,
            callback: callback,
        })
    }
    
    render() {
        const { detalhes, dataTable } = this.state
        const edit = this.redirectId ? true : false
        const displayExterno = detalhes.tipo?.value == "externo" ? "flex" : "none"
        const checkFields = detalhes.tipo?.value == "interno" ? ["aplicacao", "dispositivo", "acesso"] : ["aplicacao", "dispositivo"]
        const buttonDisabled = checkFields.find((item) => detalhes[item] == null) ? true : false


        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }

        const { Option } = components
        const IconOption = (props) => {
            const disabled = props?.data?.isDisabled
            return (
                <Option {...props}>
                    <span className="d-flex align-items-center">
                        <i style={{ fontSize: '16px', color: disabled ? "#cf2b2b" : '#2bb33f', borderRadius: "8px" }} className="fa fa-square mr-1"></i>
                        <b style={{ color: '#222', fontWeight: 'normal', opacity: disabled ? 0.7 : 1 }}>{props?.data?.label} Disponíveis = {props?.data?.acessosDisponiveis}</b>
                    </span>
                </Option>
            )
        }

        return (
            <div>
                {!this.props.isQuickRegister &&
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc">
                            {!this.props.isQuickRegister &&
                                <i
                                    className="fa fa-info-circle fa-20px"
                                    title='Informações do Cadastro de Redirecionamentos'
                                    style={{ cursor: "pointer", marginTop: '8px', marginRight: '5px' }}
                                    onClick={() =>
                                        helper.dispatchEvent("showAviso", {
                                            message: `
                                                    Define para onde os dados recebidos serão enviados:<br /><br />
                                                    <strong>Interno</strong> — Visualização e processamento diretamente na plataforma. Requer plano de acesso contratado.<br /><br />
                                                    <strong>Externo</strong> — Dados enviados para um broker MQTT de sua escolha, para integração com seus próprios sistemas.
                                                `,
                                        })
                                    }
                                />
                            }
                            {this.redirectId ? <h4>Editar Redirecionamento</h4> : <h4>Novo Redirecionamento</h4>}
                            <div className="gray-background">
                                <i className="las la-reply la-2x"></i>
                            </div>
                        </span>
                    </div>
                }

                <Tabs className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.handleTab(i)}>
                    <TabList>
                        <Tab>Geral</Tab>
                        <Tab>Dispositivos</Tab>
                    </TabList>
                    
                    <TabPanel>
                        <div className="hdv-form-default">

                            <div className="row">
                                <div className="col-md-12">
                                    <label className='required'>Cliente</label>
                                    <Select
                                        value={detalhes.cliente}
                                        disabled={edit || this.isCustomer}
                                        options={this.state.optionsClientes}
                                        onChange={(e) => this.handleChange("cliente", e)}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <label className='required' htmlFor="nome">Nome</label>
                                    <input
                                        type='text'
                                        value={detalhes.nome ?? ""}
                                        id="nome"
                                        onChange={(e) => this.handleChange("nome", e.target.value)}
                                    />
                                    <span id='validacao-nome'></span>
                                </div>
                                <div className="col-md-6">
                                    <label className='required'>
                                        Tipo
                                        &nbsp;
                                        <i className="fa fa-info-circle" title={this.state.info[detalhes.tipo?.value]} style={{cursor: "pointer"}} onClick={() => this.showInfo(this.state.info[detalhes.tipo?.value])}></i>
                                    </label>
                                    <Select
                                        value={detalhes.tipo}
                                        disabled={edit}
                                        options={this.state.optionsTipo} 
                                        onChange={(e) => this.handleChange("tipo", e)}
                                    />
                                    <span id='validacao-tipo'></span>
                                </div> 
                            </div>

                            <div className="row" style={{display: displayExterno}}>
                                <div className="col-md-3">
                                    <label className='required' htmlFor="broker">Broker</label>
                                    <input
                                        type='text'
                                        value={detalhes.broker ?? ""}
                                        id="broker"
                                        onChange={(e) => this.handleChange("broker", e.target.value)}
                                    />
                                    <span id='validacao-broker'></span>
                                </div>
                                <div className="col-md-4">
                                    <label className='required' htmlFor="porta">Porta</label>
                                    <input
                                        type='text'
                                        value={detalhes.porta ?? ""}
                                        id="porta"
                                        onChange={(e) => this.handleChange("porta", e.target.value, true)}
                                    />
                                    <span id='validacao-porta'></span>
                                </div>
                                <div className="col-md-4">
                                    <label className='required' htmlFor="qos">QoS</label>
                                    <input
                                        type='text'
                                        value={detalhes.qos ?? ""}
                                        id="qos"
                                        onChange={(e) => this.handleChange("qos", e.target.value, true)}
                                    />
                                    <span id='validacao-qos'></span>
                                </div>
                                <div className="col-md-1">
                                    <label className='required' htmlFor="tls">TLS</label>
                                    <input
                                        id="tls"
                                        type='checkbox'
                                        checked={detalhes.tls}
                                        onChange={(e) => this.handleChange("tls", e.target.checked)}
                                    />
                                </div>
                            </div>

                            <div className="row" style={{display: displayExterno}}>
                                <div className="col-md-6">
                                    <label className='required' htmlFor="topico_pub">Tópico de Publicação</label>
                                    <input
                                        type='text'
                                        value={detalhes.topico_pub ?? ""}
                                        id="topico_pub"
                                        onChange={(e) => this.handleChange("topico_pub", e.target.value)}
                                    />
                                    <span id='validacao-topico_pub'></span>
                                </div>
                                <div className="col-md-6">
                                    <label className='required' htmlFor="topico_sub">Tópico de Inscrição</label>
                                    <input
                                        type='text'
                                        value={detalhes.topico_sub ?? ""}
                                        id="topico_sub"
                                        onChange={(e) => this.handleChange("topico_sub", e.target.value)}
                                    />
                                    <span id='validacao-topico_sub'></span>
                                </div>
                            </div>

                            <div className="row" style={{display: displayExterno}}>
                                <div className="col-md-6">
                                    <label className='required' htmlFor="usuario">Usuário</label>
                                    <input
                                        type='text'
                                        value={detalhes.usuario ?? ""}
                                        id="usuario"
                                        onChange={(e) => this.handleChange("usuario", e.target.value)}
                                    />
                                    <span id='validacao-usuario'></span>
                                </div>
                                <div className="col-md-6">
                                    <label className='required' htmlFor="senha">Senha</label>
                                    <input
                                        type='text'
                                        value={detalhes.senha ?? ""}
                                        id="senha"
                                        onChange={(e) => this.handleChange("senha", e.target.value, false, true)}
                                    />
                                    <span id='validacao-senha'></span>
                                </div>
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel>
                        <div className="hdv-form-default">
                            <div className="row">
                                <div className={detalhes.tipo?.value == "interno" ? "col-md-3" : "col-md-4"}>
                                    <label className='required'>Aplicação</label>
                                    <Select
                                        value={detalhes.aplicacao}
                                        options={this.state.optionsAplicacao} 
                                        onChange={(e) => this.handleChange("aplicacao", e)}
                                    />
                                </div>
                                <div className={detalhes.tipo?.value == "interno" ? "col-md-3" : "col-md-4"}>
                                    <label className='required'>Dispositivo</label>
                                    <Select
                                        value={detalhes.dispositivo}
                                        options={this.state.optionsDispositivo} 
                                        onChange={(e) => this.handleChange("dispositivo", e)}
                                    />
                                </div>
                                <div className="col-md-3" style={{display: detalhes.tipo?.value == "interno" ? "block" : "none"}}>
                                    <label className='required'>Acesso</label>
                                    <Select
                                        components={{ Option: IconOption }}
                                        value={detalhes.acesso}
                                        options={this.state.optionsAcesso} 
                                        onChange={(e) => this.handleChange("acesso", e)}
                                    />
                                </div>
                                <div className={`${detalhes.tipo?.value == "interno" ? "col-md-3" : "col-md-4"} d-flex align-items-end`}>
                                    <button 
                                        onClick={this.addDispositivo} 
                                        disabled={buttonDisabled}
                                        className="hdv-btn-forms hdv-btn-green" 
                                        style={{width: "100%", margin: "0px", height: "44px"}}
                                    >Adicionar</button>
                                </div>
                                <span id="validacao-dispositivo" style={{margin: "3px 15px"}}></span>
                            </div>
                        </div>

                        <br/>
                        {
                            dataTable.length === 0 ? (
                                <div className="d-flex justify-content-center align-items-center" style={{height: "100px"}}>
                                    <div>Nenhum dispositivo redirecionado</div>
                                </div>
                            ) : (
                                <table className="table afira-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={detalhes.tipo?.value == "interno" ? 3 : 2}>Lista de dispositivos</th>
                                            <th className="hdv-subtable-action-td" style={{textAlign: "center"}}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataTable.map((item, index) => {
                                                if(detalhes.tipo?.value == "interno"){
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.aplicacao?.label}</td>
                                                            <td>{item.dispositivo?.label}</td>
                                                            <td>{item.acesso?.label}</td>
                                                            <td className="hdv-subtable-action-td" style={{textAlign: "center"}}> 
                                                                <ConfirmDelete
                                                                    enabled={true}
                                                                    action={() => this.deletarDispositivo(index)}
                                                                    label="Remover"
                                                                    style={{marginRight: "0"}}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                } else {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.aplicacao.label}</td>
                                                            <td>{item.dispositivo.label}</td>
                                                            <td className="hdv-subtable-action-td" style={{textAlign: "center"}}> 
                                                                <button className="hdv-btn-forms hdv-btn-red" onClick={() => this.deletarDispositivo(index)}>Deletar</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }
                                    </tbody>
                                </table>
                            )
                        }
                    </TabPanel>
                </Tabs>


                {!this.props.isQuickRegister &&
                    <div className="hdv-btn-group">
                        <ButtonsForm
                            route="/lns/redirecionamentos"
                            edit={this.redirectId ? true : false}
                            cooldown={this.state.cooldown}
                            buttons={[
                                {
                                    method: "post",
                                    button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                },

                                {
                                    method: "post",
                                    button: <button style={{ display: this.redirectId ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                                },

                                {
                                    method: "patch",
                                    button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                },
                            ]}
                        />

                        <button className="hdv-btn-forms hdv-btn-orange" onClick={this.state.hasChangedSomething ? () => this.showInfo("Você não salvou as alterações realizadas, deseja realmente cancelar?", () => this.props?.history?.goBack()) : () => this.props?.history?.goBack()}>Cancelar</button>
                    </div>
                }
            </div>
        )
    }
}

export default Form